import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const COLORS = ['#1976D2', '#4CAF50', '#FF9800', '#F44336', '#9C27B0', '#00BCD4', '#FFC107', '#795548'];

export default function OemBreakdownChart({ data, loading, onOemClick }) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Tariff by OEM</CardTitle>
          <CardDescription>Distribution across manufacturers</CardDescription>
        </CardHeader>
        <CardContent className="h-80 flex items-center justify-center bg-gray-50 rounded-lg animate-pulse">
          <span className="text-gray-400">Loading chart...</span>
        </CardContent>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Tariff by OEM</CardTitle>
          <CardDescription>Distribution across manufacturers</CardDescription>
        </CardHeader>
        <CardContent className="h-80 flex items-center justify-center bg-gray-50 rounded-lg">
          <span className="text-gray-500">No OEM data available</span>
        </CardContent>
      </Card>
    );
  }

  const chartData = data.map(item => ({
    name: item.oem,
    value: item.tariff_cents / 100,
    percentage: item.percentage
  }));

  const formatCurrency = (value) => {
    return `$${value.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tariff by OEM</CardTitle>
        <CardDescription>Click a slice to filter dashboard</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={320}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percentage }) => `${name}: ${percentage.toFixed(1)}%`}
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
              onClick={(data) => onOemClick && onOemClick(data.name)}
              style={{ cursor: 'pointer' }}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="bg-white p-3 shadow-lg rounded-lg border border-gray-200">
                      <p className="font-semibold text-gray-900 mb-1">{payload[0].name}</p>
                      <p className="text-sm text-gray-600">
                        Tariff: <span className="font-medium text-gray-900">{formatCurrency(payload[0].value)}</span>
                      </p>
                      <p className="text-sm text-gray-600">
                        Share: <span className="font-medium text-gray-900">{payload[0].payload.percentage.toFixed(1)}%</span>
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
